<template>
  <div>
    <b-card-body>
      <b-card>
        <div class="log-details">
          <div>
            <label class="mr-3 bold">{{ $t("modal-detail-log-data") }}</label>
            <p>{{ dateBR(log.date) }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{
              $t("modal-detail-log-usuario")
            }}</label>
            <p>{{ log.userName }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{ $t("modal-detail-log-modulo") }}</label>
            <p>{{ log.modulo }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{
              $t("modal-detail-log-unidade")
            }}</label>
            <p>{{ log.productionUnit }}</p>
          </div>
        </div>
        <div class="log-details" v-if="user.Id == 2">
          <div>
            <label class="mr-3 bold">{{ $t("api") }}</label>
            <p>{{ log.api }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{ $t("rota") }}</label>
            <p>{{ log.path }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{ $t("tabela") }}</label>
            <p>{{ log.table }}</p>
          </div>
          <div></div>
        </div>

        <div class="log-description-banner">
          <h3>{{ log.description }}</h3>
        </div>

        <div class="log-description-content">
          <pre>{{ `${log.message}` }}</pre>
        </div>

        <div class="groupBtn mt-4">
          <img
            src="@/assets/sair.png"
            :alt="$t('sair')"
            :title="$t('sair')"
            @click="onClose"
          />
        </div>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LogDetailsModal",
  computed: mapState(["user"]),
  props: {
    log: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  methods: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ");
      dateBr = info[0];
      let time = info[1];
      if (dateBr == "Invalid" || date == "1900-01-01 00:00:00") {
        return "Aguardando dados do servidor ";
      } else {
        return (dateBr = dateBr + " " + time);
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.log-details {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.log-details div {
  flex: 1;
}

.log-description-banner {
  background-color: #343a40;
  color: white;
  text-align: center;
  padding: 10px 0;
  height: 50px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.log-description-banner > h3 {
  font-size: 1rem;
}

.log-description-content {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 1rem;
  background: #f9f9f9;
  overflow-y: auto;
  max-height: 20rem;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.bold {
  font-weight: bold;
}
</style>
